import { find } from 'ramda'
import { useTranslation } from 'react-i18next'

import { OptionProps, OptionProp } from 'app/common/ui-next/option-props'
import * as types from 'app/common/constants/identifiers/types'

import { Number } from './markup'
import styles from './prop-identifier-numbers.module.scss';


const titles = [
  'Wiegand 26',
  'Wiegand 34',
  'Wiegand 58',
]

type Props = {
  numbers: Array<string | null>,
  defaultNumber: string,
  type: typeof types[keyof typeof types]
  bankCardSpecial?: boolean
  bankCardLastDigits: string | null
}

const IdentifierNumbers = ({ numbers, defaultNumber, type, bankCardSpecial, bankCardLastDigits }: Props) => {
  const { t } = useTranslation('identifiers-next')
  const showDefault = !find(number => !!number, numbers)

  if (bankCardSpecial && type === types.IDENTIFIER_BANK_CARD) {
    return (
      <OptionProps>
        <OptionProp
          title={t('bank_card_list_title', 'Номер карты')}
          className={styles.prop}
        >
          <Number>{`**** **** **** ${bankCardLastDigits || '****'}`}</Number>
        </OptionProp>
      </OptionProps>
    )
  }

  return (
    <OptionProps className={styles.root}>
      {showDefault
        && <div>
          <OptionProp
            title={t('default_number_title', 'Номер')}
            className={styles.prop}
          >
            <Number>{defaultNumber}</Number>
          </OptionProp>
        </div>}

      {numbers.map((num, i) => (num
        ? <div key={num}>
          <OptionProp
            title={titles[i] || t('default_number_title', 'Номер')}
            className={styles.prop}
          >
            <Number>{num}</Number>
          </OptionProp>
        </div>
        : null
      ))}
    </OptionProps>
  )
}

export default IdentifierNumbers
